import React from "react";
import ReactDOM from "react-dom";
import { ScrollCue } from '../components/ScrollCue';
import { SocialCards } from '../components/SocialCards';
import { ModalAutoActions } from '../components/ModalAutoActions';
import ReadMore from '../components/ReadMore';
import { MediaModal } from '../components/Modals';
import { SetPopupStartTime } from '../components/WebStorage';
require('../../sass/main.scss');

const SetupScrolling = (): void => {
    $(document).ready(function () {
        var scrollOrigin = document.getElementById('scrollOrigin')
        var scrollTarget = document.getElementById('discoverTheMagic')

        if (scrollOrigin && scrollTarget) {
            scrollOrigin.addEventListener('click', () => {
                scrollTarget.scrollIntoView({
                    behavior: 'smooth'
                })
            })
        }
    });
}

const SetupModals = (): void => {
    $(document).ready(function () {
        const mediaModal = document.createElement('div')
        if (mediaModal) {
            document.body.appendChild(mediaModal)
            ReactDOM.render(<MediaModal />, mediaModal)
        }
    });
}

SetupModals();
SocialCards();
ScrollCue();
ModalAutoActions();
SetupScrolling();
ReadMore();
SetPopupStartTime();
